import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './store/configureStore';
import App from './App';
import { Unauthorized } from './Unauthorized';
import * as AuthStore from './store/Auth';
import { createTheme, ThemeProvider } from '@mui/material';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore();

const AuthWatcher = (props: { children: React.ReactNode }): any => {
    const authError = useSelector(AuthStore.selectors.getError);
    if (authError) {
        return <Unauthorized />;
    }
    return props.children;
};

const theme = createTheme({
    palette: {
        primary: {
            main: '#2196f3'
        },
        secondary: {
            main: '#ffc400'
        },
        background: {
            default: '#fafafa'
        }
    }
});

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <BrowserRouter basename={baseUrl}>
            <AuthWatcher>
                <ThemeProvider theme={theme}>
                    <App />
                </ThemeProvider>
            </AuthWatcher>
        </BrowserRouter>
    </Provider>
);